var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('cld-video',{attrs:{"publicId":_vm.video,"width":"100%","controls":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }